<template>
  <div
    v-if="topic.id !== 1"
    class="flex flex-col rounded-xl shadow-card overflow-hidden"
    :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
    :style="{ order: topic.id }"
  >
    <div
      class="border-b px-4 py-3.5"
      :class="mode === 'dark' ? 'border-dark-50' : 'border-gray-100'"
    >
      <span class="font-semibold text-[17px] leading-none">{{
        capitalizeFirstLetter(topic.name)
      }}</span>
    </div>
    <div
      v-if="articles && articles.results.length > 0"
      class="px-4 py-3 without-scrollbar max-h-[350px] overflow-y-auto"
    >
      <ul class="list-disc pl-4 grid gap-2">
        <template v-for="(article, index) in articles.results">
          <li
            v-if="article.topic === topic.id"
            :key="index"
            :style="{ order: article.id }"
            :class="[
              mode === 'dark'
                ? 'text-gray-100 text-opacity-70'
                : 'text-gray-700',
            ]"
          >
            <a
              :href="`https://www.seocopilotai.com/knowledge-base/${article.slug}?topic=${topic.id}`"
              target="_blank"
              class="text-[15px] capitalize block hover:text-primary-100 transition-colors duration-150 text-wrap max-w-[400px]"
              :class="[
                mode === 'dark'
                  ? 'text-gray-100 text-opacity-70'
                  : 'text-gray-700',
              ]"
              >{{ article.title }}</a
            >
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  props: {
    topic: {
      type: Object,
    },
    mode: {
      type: String,
    },
  },
  data() {
    return {
      articles: null,
    };
  },
  mounted() {
    this.getArticles(this.topic.id);
  },
  methods: {
    async getArticles(id) {
      const url = `https://api.seocopilotai.com/api/v1/articles/?topic=${id}`;
      try {
        const response = await axios.get(url);
        this.articles = response.data;
      } catch (error) {
        this.$toast.error("Error fetching articles:", error.message);
      }
    },
    capitalizeFirstLetter(str) {
      if (!str) return "";
      str = str.toLowerCase();
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
};
</script>
